// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import facets from './facets';
import hasSearchResults from '../../shared/reducers/has-search-results';
import registrations from './registrations';
import reportsAccordion from './reports-accordion';
import searchByDropDown from '../../shared/reducers/search-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';

export default {
    registrationReview: combineReducers({
        busyCounter,
        facets,
        hasSearchResults,
        registrations,
        reportsAccordion,
        searchByDropDown,
        searchFilters,
        searchQueryString
    })
};



// WEBPACK FOOTER //
// ./src/product/registration-review/reducers/index.js